import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { EnvironmentUtils } from 'utils'
import { keepTokenAlive } from 'core/session/slices/session'

const DEFAULT_SAFE_INTERVAL_SECONDS: number = 30

const SessionLayer: React.FC = ({ children }) => {
  const dispatch = useDispatch()

  // Keep session alive
  useEffect(() => {
    const { allowKeepSessionAlive, allowedSessionIdleDurationInSeconds } =
      EnvironmentUtils.getPermissions('general')
    if (allowKeepSessionAlive) {
      const durationInterval =
        allowedSessionIdleDurationInSeconds > DEFAULT_SAFE_INTERVAL_SECONDS
          ? allowedSessionIdleDurationInSeconds - DEFAULT_SAFE_INTERVAL_SECONDS
          : allowedSessionIdleDurationInSeconds
      const keepAliveInterval = setInterval(
        () => dispatch(keepTokenAlive()),
        durationInterval * 1000
      )
      return () => clearInterval(keepAliveInterval)
    }
  }, [dispatch])

  return <>{children}</>
}

export default SessionLayer
